import { MESApiService, spParameter } from "@dexteel/mesf-core";

export const getHealthStatusReport = async () => {
	const apiService = new MESApiService();
	const parameters: spParameter[] = [];
	return await apiService.callV2("[SWV].[GetHealthStatus]", parameters);
};
